/**
 * 카드결제 전표 마크업 ($j.F.CardReceipt) — 전표 한 장(.ui-receipt)을 문자열로 만든다.
 *
 * 회원 앱(/m/cardpay 전표 보기·이미지 저장), 관리자 결제 상세(/adm/cardpay), 불러톡 공유 이미지(F/Admin/CardPay/ReceiptShare)가
 * 전부 이 함수 하나를 쓴다 — 구성·문구·치수를 한 곳에서만 고친다.
 * 스타일은 shared/components/_card-receipt.scss (토큰 --ui-receipt-*, 기본값 = 흰 종이). 색을 바꾸려는 사이트가 자기 번들에서 토큰을 잇는다.
 *
 * 구성: 머리(신용카드 / 매출전표) · 거래정보 · 결제 작업(주소 + 장비 + 금액) · 회색 바닥(승인금액·부가세·합계 + 가맹점 정보)
 *   묶음은 건마다 한 줄, 단건·직접입력·외부배차는 한 줄. 장기선결제는 현장이 없어 결제 작업 대신 상품구분만 적는다.
 */
export default class CardReceipt {
    /**
     * @param {object} item  결제 1건 — CardPaymentService::shapeItem 모양(cardCo·approvalNo·payDate·cancelDate·quotaText·
     *                       works[]·addr·eq·amt·vat·purpose·workDate)
     * @param {object} [opt]
     * @param {boolean} [opt.cancel]   취소전표로 그린다(제목·거래상태·합계가 취소 표기)
     * @param {object}  [opt.merchant] 가맹점 정보 {name, ceo, bizNo, phone, addr} — 없으면 item.merchant
     * @returns {string} HTML
     */
    build(item, opt = {}) {
        item = item || {};
        const isC = !!opt.cancel;
        const m = opt.merchant || item.merchant || {};
        const cc = isC ? ' is-cancel' : '';
        const esc = (v) => String(v == null ? '' : v).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
        const won = (n) => Number(n || 0).toLocaleString() + '원';
        const amt = Number(item.amt || 0);
        const vat = Number(item.vat || 0);

        const row = (k, v, cls) => `<div class="ui-receipt__row"><span class="ui-receipt__k">${k}</span><span class="ui-receipt__v${cls || ''}">${esc(v)}</span></div>`;
        const job = (addr, eq, sum) => `<div class="ui-receipt__job"><div class="ui-receipt__job-l"><span class="ui-receipt__job-addr">${esc(addr || '-')}</span>`
            + (eq ? `<span class="ui-receipt__job-eq">${esc(eq)}</span>` : '') + `</div><span class="ui-receipt__job-amt">${won(sum)}</span></div>`;
        const info = (k, v) => `<div class="ui-receipt__mi"><span class="ui-receipt__mk">${k}</span><span class="ui-receipt__mv">${esc(v || '-')}</span></div>`;

        const works = (item.works && item.works.length > 1) ? item.works : null;
        const isLong = item.purpose === 'long';   // 장기선결제 — 현장이 아니라 상품·대상 기사

        let extra = '';
        if (!works && isLong) extra = row('상품구분', item.addr || '장기선결제');
        else if (!works && item.purpose === 'ext') extra = row('상품구분', '외부배차') + (item.workDate ? row('작업일', item.workDate) : '');

        let jobs = '';
        if (works) {
            jobs = `<div class="ui-receipt__jobs"><div class="ui-receipt__sec">결제 작업 · 총 ${works.length}건</div>`
                + works.map((w) => job(w.addr, w.eq || '작업', Number(w.amt || 0) + Number(w.vat || 0))).join('') + '</div>';
        } else if (!isLong) {
            jobs = '<div class="ui-receipt__jobs"><div class="ui-receipt__sec">결제 작업</div>' + job(item.addr, item.eq, amt + vat) + '</div>';
        }

        return `<div class="ui-receipt">`
            + `<div class="ui-receipt__hd${cc}"><span class="ui-receipt__sub">신용카드</span><span class="ui-receipt__tt">${isC ? '취소전표' : '매출전표'}</span></div>`
            + `<div class="ui-receipt__rows">`
            + row('카드사 / 승인번호', (item.cardCo || '-') + ' / ' + (item.approvalNo || '-'))
            + row(isC ? '취소일시' : '거래일시', isC ? (item.cancelDate || '-') : (item.payDate || '-'))
            + row('거래상태 / 할부', (isC ? '취소' : '승인') + ' / ' + (item.quotaText || '일시불'), cc)
            + extra
            + `</div>`
            + jobs
            + `<div class="ui-receipt__foot">`
            + `<div class="ui-receipt__sum">`
            + `<div class="ui-receipt__amt"><span class="ui-receipt__k">승인금액</span><span class="ui-receipt__v">${won(amt)}</span></div>`
            + `<div class="ui-receipt__amt"><span class="ui-receipt__k">부가세</span><span class="ui-receipt__v">${won(vat)}</span></div>`
            + `<div class="ui-receipt__total${cc}"><span class="ui-receipt__total-k">합계</span><span class="ui-receipt__total-v">${won(amt + vat)}</span></div>`
            + `</div>`
            + `<div class="ui-receipt__merchant"><div class="ui-receipt__sec">가맹점 정보</div><div class="ui-receipt__mgrid">`
            + info('가맹점명', m.name) + info('대표자', m.ceo) + info('사업자번호', m.bizNo) + info('연락처', m.phone) + info('주소', m.addr)
            + `</div></div>`
            + `</div>`
            + `</div>`;
    }
}
